<template>
  <div v-if="analysisResult != null">
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Analiz Sonuçu">
          <!-- <b-alert variant="warning" show class="mb-0">
                  <div class="alert-body mb-2">
                    <span
                      ><strong>Not:</strong> Eklenecek içerik adı ve arama motoru
                      bağlantı linki benzersiz olmalıdır...</span
                    >
                  </div>
                </b-alert> -->
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            :to="`/analysis-results`"
          >
            Analiz Sonuçları
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Analiz Sonuçu">
          <b-row>
            <b-col cols="12">
              <div class="d-flex align-items-center justify-content-center mt-1">
                <h5>Uyruk: {{ analysisResult.nationality.nationality }}</h5>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="d-flex align-items-center justify-content-center mt-1">
                <h5>Doğum Tarihi: {{ analysisResult.birthday }}</h5>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="d-flex align-items-center justify-content-center mt-1">
                <h5>Oluşturma Tarihi: {{ analysisResult.createdAt }}</h5>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="4"
              v-for="product in analysisResult.products"
              :key="`product-${product.id}`"
            >
              <div class="d-flex align-items-center justify-content-center mt-5">
                <b-img :src="product.images.productImage" width="100" />
              </div>
              <div class="d-flex align-items-center justify-content-center mt-1">
                <h3>{{ product.name }}</h3>
              </div>

              <div class="d-flex align-items-center justify-content-center mt-1">
                <h4>
                  Skor:
                  {{
                    analysisResult.scores.find(
                      (element) => element.productId == product.id
                    ).totalScore
                  }}
                </h4>
              </div>
              <div class="d-flex align-items-center justify-content-center mt-1">
                <h4>
                  Yüzde:
                  {{
                    analysisResult.scores.find(
                      (element) => element.productId == product.id
                    ).percentage
                  }}
                </h4>
              </div>
            </b-col>
            </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BAlert,
    BBadge,
    BButton,
    BAvatar,
    BCardText,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      id: this.$route.params.idParam,
      analysisResult: null,
    };
  },
  watch: {},
  methods: {
    getQuestions() {
      endpoints
        .getQuestions(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.questions = [...data.response];
          this.getAnalysisResultById();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAnalysisResultById() {
      endpoints
        .getAnalysisResultById(this.id, this.$i18n.locale, () => {})
        .then((data) => {
          this.analysisResult = data.response;
      
        })
        .catch((err) => {
          console.log(err);
        });
    },

  },
  mounted() {
    this.getQuestions();

  },
};
</script>
